module.exports = __webpack_public_path__ + "img/Cryo-no-logo.f064bd6a.jpg";